<template lang="pug">
  div(class="py-2")
    div(v-if="ListModel.data.length")
      div(class="d-grid grid-table border" style="grid-template-columns: 132px 2fr 1fr 1fr 1fr 1fr 1fr 1fr;")
        div(class="text-center title") 商品
        div(class="text-center title")
        div(class="text-center title") 單價
        div(class="text-center title") 積分
        div(class="text-center title") 數量
        div(class="text-center title") 金額小計
        div(class="text-center title") 積分小計
        div(class="text-center title") 移除
        ProdGrid(v-for="model in sortedShopCartItems" :model="model" :key="model.id" :edit="true" :change="changeQuantity" :loadcart="loadShoppingCart" :isRemove="true")
        ProdGrid(v-for="model in stockEmpty" :model="model" :key="model.id")
        ActivitieProdGridItem(v-for="model in activity_items" :model="model" :key="model.id")
        div(class="grid-span line ")
        div(class="grid-span row " style="padding-left:10px")
          div(class=" px-3 py-2 col-sm-12 col-md-8" style="color: #AE0000;")
            span ‧ 提醒您！
              a(href="/service/1/8") 運費收取說明 <br />
            span ‧ 本島訂貨總金額滿$5,000元即可享免運。<br />
            span ‧ 外島訂貨總金額滿$10,000元即可享免運。
          div(class="px-3 py-2 max-w-lg-250 col-sm-12 col-md-4" )
            div(class="d-flex py-2 ")
              div(class="text-dark totle-count-title") 訂單金額總計
              div(class=" text-danger font-weight-bold") NT$ {{ commaFormat(mathTotalPrice) }}
            div(class="d-flex py-2 ")
              div(class="text-dark totle-count-title") 訂單積分總計
              div(class="text-primary font-weight-bold") {{ commaFormat(mathTotalPv) }}
      div(class="py-2" v-if="finalActivities.length")
        div(class="border fs-lg-16 fs-14")
          div(class="border-bottom text-center py-2") 特惠活動
          ActivitieGrid(v-for="(model, index) in finalActivities" :showText="true" :updateView="updateView" :model="model" :hasLimit="model.hasLimit" :key="model.id" :edit="true" :disabled="checkingCart" :class="{'border-top': index}")
    div(v-else)
      h2(class="text-center py-5") 購物車沒有任何商品
    div(class="row mx-n1 py-2 justify-content-end align-items-center flex-column flex-lg-row")
      router-link(class="w-100 btn btn-outline-success m-1 max-w-300 max-w-lg-180" to="/product/list") 繼續購物
      button(class="w-100 btn btn-outline-success m-1 max-w-300 max-w-lg-180" type="button" v-if="ListModel.data.length" @click="deleteShopcartAll") 清除購物車
      button(class="w-100 btn btn-success m-1 max-w-300" type="button" @click="nextStep" :disabled="checkingCart" v-if="ListModel.data.length")
        span(class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="checkingCart")
        span {{ checkingCart ? '處理中...' : '下一步' }}
</template>

<script>
import dayjs from 'dayjs'
import { mapState, mapActions } from 'vuex'
import ProdGrid from '../../../container/order/ProdGrid.vue'
import ActivitieGrid from '../../../container/order/ActivitieGrid.vue'
import ActivitieProdGrid from '../../../container/order/ActivitieProdGrid.vue'
import ActivitieProdGridItem from '../../../container/order/ActivitieProdGridItem.vue'
import { createShopcart, deleteShopcartAll, getShopcartAvailability } from '../../../api'
import { ProductsModel, OrderItemModel, ActivitieModel } from '../../../models'
import { Toast } from '@/utils/helper'
import Swal from 'sweetalert2'
import {
  isShoppingMaintenanceClosed,
  showShoppingMaintenanceAndReturnHome
} from '@/library/shopping-maintenance'

function isMaintenanceError (error) {
  return Boolean(
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message === '網站關閉維護中'
  )
}

function getProductNumberValue (model) {
  return String(
    (model &&
      model.products &&
      model.products.product_number) ||
      model.product_number ||
      ''
  ).trim()
}

function compareByProductNumber (left, right) {
  const leftNumber = getProductNumberValue(left)
  const rightNumber = getProductNumberValue(right)
  const leftValue = Number(leftNumber)
  const rightValue = Number(rightNumber)
  const leftIsNumeric = !Number.isNaN(leftValue)
  const rightIsNumeric = !Number.isNaN(rightValue)

  if (leftIsNumeric && rightIsNumeric && leftValue !== rightValue) {
    return leftValue - rightValue
  }

  if (leftNumber !== rightNumber) {
    return leftNumber.localeCompare(rightNumber, 'zh-Hant', { numeric: true })
  }

  return Number(left.id || 0) - Number(right.id || 0)
}

function escapeHtml (value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

function stockMessageList (items) {
  const rows = (Array.isArray(items) ? items : [])
    .map(item => `<li style="padding-left:2px;line-height:1.55;font-weight:600;">${escapeHtml(item)}</li>`)
    .join('')

  return `<ul style="width:fit-content;max-width:100%;margin:16px auto 0;padding-left:22px;color:#555;text-align:left;">${rows}</ul>`
}

export default {
  name: 'step1',
  data() {
    return {
      OrderModel: this.$parent.model,
      stockEmpty: [],
      listModel: [],
      activity_items: [],
      renewal_expiry_date: 0,
      expiry_date: 0,
      pendingQuantityUpdates: [],
      checkingCart: false
    }
  },
  created() {
    if (!this.UserData.loginStatus) {
      this.$store.commit('setLoginPage', this.$route.path)
      this.$router.replace('/member/login')
      return
    }
    this.$parent.step = 1
    this.getListModel({ name: 'SettlementDays' })
    this.getListModel({ name: 'ShopSystems' })
    this.getListModel({ name: 'ShoppingRules' })
    this.getListModel({ name: 'LoveCodes' })

    Swal.fire({
      title: '載入中...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    })

    // 付款狀態尚未確認不應阻止會員查看或修改購物車。
    // 相同內容的重複下單仍會在送出訂單前由 Step4 與後端檢查。
    this.loadShoppingCart()

    this.UserData.login().then(() => {
      // console.log('this.UserData', this.UserData)
      if (this.UserData.exited_at !== null) {
        this.$store.commit('logout')
        Toast.fire({
          icon: 'success',
          title: '已成功登出'
        }).then(() => {
          this.$router.replace('/home')
        })
      }
    })

    this.OrderModel.activities.map(a => {
      this.activity_items = this.activity_items.concat(a.activity_items)
      return a.activity_items
    })
  },
  computed: {
    ...mapState({
      ListModel: state => state.model.ShopCarts,
      Products: state => state.model.Products,
      SettlementDays: state => state.model.SettlementDays,
      ShopSystems: state => state.model.ShopSystems,
      Activities: state => state.model.Activities,
      UserData: state => state.model.UserData,
      ShopCarts: state => state.model.ShopCarts
    }),
    isTester() {
      return this.UserData.is_tester
    },
    finalActivities() {
      return this.OrderModel.activities.filter(
        a => !a.is_testing || this.isTester
      )
    },
    sortedShopCartItems () {
      return [...this.ListModel.data].sort(compareByProductNumber)
    },
    // ...mapActions(['removeShopcartByProdId']),
    mathTotalPrice() {
      // 計算總金額
      return this.ListModel.data
        .map(item => {
          const total = item.products.member_price * item.product_quantity
          return this.maxLimitedBuy(item.products) ? total : 0
        })
        .reduce((a, b) => Number(a) + Number(b), 0)
    },
    mathTotalPv() {
      // 計算總積分
      return this.ListModel.data
        .map(item => {
          const total = item.products.pv * item.product_quantity
          return this.maxLimitedBuy(item.products) ? total : 0
        })
        .reduce((a, b) => Number(a) + Number(b), 0)
    },
    isShopSystemClose() {
      const system = this.ShopSystems.data.length
        ? this.ShopSystems.data[0]
        : false
      if (!system) {
        return true
      }
      return isShoppingMaintenanceClosed(system)
    },
    isLuckyProductInShopCart() {
      return this.ListModel.data.filter(p => p.fortune_word)
    }
  },
  // beforeUpdate () {
  //   const isTester = this.UserData.is_tester
  //   this.ShopCarts.data.forEach(item => {
  //     if (item.products.status === 0 && !isTester) {
  //       // console.log(item.products.id)
  //       this.$store.dispatch('removeShopcartByProdId', item.products.id)
  //     }
  //   })
  // },
  updated() {
    console.log('updated', this.ShopCarts)
    console.log('activity_items', this.activity_items)
  },
  methods: {
    ...mapActions(['getListModel', 'getModelById', 'removeShopcartByProdId']),
    async getShopCarts() {
      // 取得最新的 Shopcart 的資料
      const availability = await getShopcartAvailability()
      const latestRows = Array.isArray(availability.data.items)
        ? availability.data.items
        : []
      const removedItems = Array.isArray(availability.data.removed_items)
        ? availability.data.removed_items
        : []
      this.$store.commit('setListModel', {
        name: 'ShopCarts',
        type: this.ListModel.modelType,
        list: { data: latestRows }
      })
      this.ListModel.loaded = true
      const prod = await this.getProductsByIdGroup(
        this.ListModel.data.map(p => {
          // console.log(p.products)
          return Number(p.product_id)
        })
      )
      // console.log('this.ListModel.data:', this.ListModel.data)
      const adjustedProducts = []
      await Promise.all(this.ListModel.data.map(async (model, index) => {
        const Product = new ProductsModel(prod[index])
        model.products = Product
        const originalQuantity = Number(model.product_quantity || 0)
        const adjustedQuantity = this.isLuckyProduct(
          model.products.product_number
        )
          ? 1
          : Math.min(this.maxLimitedBuy(Product), originalQuantity)

        model.product_quantity = adjustedQuantity
        if (adjustedQuantity > 0 && adjustedQuantity !== originalQuantity) {
          const response = await createShopcart(model.toDatabase())
          model.set(response.data)
          model.products = Product
          adjustedProducts.push(`${Product.product_number} ${Product.name}`)
        }
      }))
      const removedProducts = removedItems.map(item =>
        `${item.product_number || ''} ${item.name || ''}`.trim()
      )
      const changed = removedProducts.length > 0 || adjustedProducts.length > 0
      if (changed) {
        await Toast.fire({
          icon: 'warning',
          title: '商品有異動，請重新檢查：',
          html: stockMessageList(
            [...adjustedProducts, ...removedProducts].sort((left, right) =>
              left.localeCompare(right, 'zh-Hant', { numeric: true })
            )
          ),
          confirmButtonColor: '#00802F',
          customClass: {
            confirmButton: 'cart-alert-confirm-button'
          }
        })
      }
      console.log(this.ListModel.data)
      return changed
      // this.ListModel.data.sort(function (a, b) {
      //   return Number(a.products.product_number) - Number(b.products.product_number)
      // })
    },
    async loadShoppingCart() {
      try {
        const cartChanged = await this.getShopCarts()
        await this.getActivitiesListModel()
        const soldOutChanged = await this.clearStockEmpty()
        Swal.close()
        return cartChanged || soldOutChanged
      } catch (error) {
        console.error('[shopcart/step1] load cart failed:', error)
        Swal.close()
        if (isMaintenanceError(error)) {
          return null
        }
        await Toast.fire({
          icon: 'error',
          title: '購物車更新失敗',
          text: '請重新檢查或稍後再試',
          confirmButtonText: '確認',
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        return null
      }
    },
    getProductsByIdGroup(arrId) {
      // 依據產品 id 取得最新的 Products 資料
      return Promise.all(
        arrId.map(id =>
          this.$store.dispatch('getModelById', { name: 'Products', id })
        )
      )
    },
    changeQuantity(e, updatePromise) {
      if (!updatePromise) {
        this.getActivitiesListModel()
        return
      }

      const trackedPromise = Promise.resolve(updatePromise)
        .then(async () => {
          await this.getActivitiesListModel()
          return true
        })
        .catch(async error => {
          console.error('[shopcart/step1] update cart quantity failed:', error)
          try {
            await this.getShopCarts()
          } catch (reloadError) {
            console.error('[shopcart/step1] reload cart failed:', reloadError)
          }
          Toast.fire({
            icon: 'error',
            title: '商品數量更新失敗，已重新載入購物車資料'
          })
          return false
        })
        .finally(() => {
          this.pendingQuantityUpdates = this.pendingQuantityUpdates.filter(
            promise => promise !== trackedPromise
          )
        })

      this.pendingQuantityUpdates.push(trackedPromise)
    },
    async waitForQuantityUpdates() {
      if (!this.pendingQuantityUpdates.length) {
        return true
      }

      const results = await Promise.all([...this.pendingQuantityUpdates])
      return results.every(Boolean)
    },
    async clearHiddenProducts() {
      if (Number(this.UserData.is_tester) === 1) {
        return
      }

      const hiddenProducts = this.ListModel.data.filter(
        model => model.products && Number(model.products.status) === 0
      )

      if (!hiddenProducts.length) {
        return
      }

      await Promise.all(
        hiddenProducts.map(model => this.removeShopcartByProdId(model.products.id))
      )
      this.ListModel.data = this.ListModel.data.filter(
        model => !hiddenProducts.includes(model)
      )
    },
    updateView() {
      console.log('updateView', this.OrderModel.activities)
      this.activity_items = []
      this.OrderModel.activities.map(a => {
        this.activity_items = this.activity_items.concat(a.activity_items)
        return a.activity_items
      })
    },
    async clearStockEmpty() {
      // 清除無庫存商品
      const arrCache = this.ListModel.data.filter(
        model =>
          model.product_quantity <= 0 &&
          !this.isLuckyProduct(model.products.product_number)
      )
      // console.log('clearStockEmpty', arrCache)

      let prodName = ''
      arrCache.forEach(model => {
        // console.log('model', model)
        if (prodName === '') {
          prodName = model.products.name
        } else {
          prodName += ',' + model.products.name
        }
      })

      if (prodName !== '') {
        const unavailableProducts = arrCache.map(
          model => `${model.products.product_number} ${model.products.name}`
        )
        await Toast.fire({
          icon: 'warning',
          title: '商品有異動，請重新檢查：',
          html: stockMessageList(unavailableProducts),
          confirmButtonColor: '#00802F',
          customClass: {
            confirmButton: 'cart-alert-confirm-button'
          }
        })
      }

      await Promise.all(
        arrCache.map(model => this.removeShopcartByProdId(model.products.id))
      )
      arrCache.forEach(model => {
        // console.log('model', model)
        this.ListModel.data = this.ListModel.data.filter(
          p => p.id !== model.id
        )
      })
      return arrCache.length > 0
    },
    async deleteShopcartAll() {
      if (confirm('是否確定要清除購物車?')) {
        await deleteShopcartAll()
        this.ListModel.data = []
        this.mathRule()
      }
    },
    async nextStep() {
      if (this.checkingCart) {
        return
      }
      this.checkingCart = true
      try {
        if (!(await this.waitForQuantityUpdates())) {
          return
        }
        const cartChanged = await this.loadShoppingCart()
        if (cartChanged === null || cartChanged) {
          return
        }
        // 完整核對及活動重算完成後，立即確認贈品是否已重新選完。
        // 放在其他結帳資格判斷之前，避免會員按「下一步」只停留原頁卻沒有回饋。
        if (this.handleActivity()) {
          await Toast.fire({
            icon: 'warning',
            title: '請選擇活動贈品',
            confirmButtonText: '確認',
            allowOutsideClick: false,
            allowEscapeKey: false
          })
          return
        }
      } finally {
        this.checkingCart = false
      }
      // console.log('next isSettlementDay')
      const isSettlementDay = this.SettlementDays.data.some(
        day =>
          dayjs().isAfter(day.started_at) && dayjs().isBefore(day.finished_at)
      )
      // console.log('isSettlementDay', isSettlementDay, this.SettlementDays.data[0].status)

      if (this.SettlementDays.data[0].status === 1 && isSettlementDay) {
        Toast.fire({
          icon: 'warning',
          title:
            '親愛的傳銷商您好，本月份業績已經進行結算作業，暫停所有產品下單，造成不便，深感抱歉!'
        }).then(() => {
          this.$parent.step = 0
          this.$router.push('/')
        })
        return
      }
      if (this.isShopSystemClose) {
        await showShoppingMaintenanceAndReturnHome(this.$router)
        return
      }
      const nowDate = new Date()
      const renewalExpiryDate = new Date(this.UserData.renewal_expiry_date)
      const expiryDate = new Date(this.UserData.expiry_day)

      // 續約截止日
      if (this.UserData.renewal_expiry_date === null) {
        this.renewal_expiry_date = 0
      } else {
        this.renewal_expiry_date =
          renewalExpiryDate.getFullYear() +
          '/' +
          (renewalExpiryDate.getMonth() + 1) +
          '/' +
          renewalExpiryDate.getDate()
      }

      // 到期日
      if (this.UserData.expiry_day === null) {
        this.expiry_date = 0
      } else {
        this.expiry_date =
          expiryDate.getFullYear() +
          '/' +
          (expiryDate.getMonth() + 1) +
          '/' +
          expiryDate.getDate()
      }

      const expiryDateOnly = new Date(expiryDate).setHours(0, 0, 0, 0)
      const nowDateOnly = new Date(nowDate).setHours(0, 0, 0, 0)

      if (
        expiryDateOnly < nowDateOnly &&
        Number(this.UserData.pv.year_pv) < 6000
      ) {
        Toast.fire({
          icon: 'warning',
          html: `提醒您！您的有效期限至 <span style = "color: red;">${this.expiry_date}</span>，請於 <span style = "color: red;">${this.renewal_expiry_date}</span> 前至各營業所辦理續約，以維護個人權益。`
        }).then(() => {
          this.$parent.step = 0
          this.$router.push('/')
        })
        return
      }
      console.log('not close')
      if (!this.UserData.email) {
        if (process.env.NODE_ENV === 'development') {
          console.log('UserData:email', this.UserData.email)
        }
        Toast.fire({
          icon: 'warning',
          title: '如需購物請至會員中心建立電子信箱'
        }).then(() => {
          this.$parent.step = 0
          this.$router.push('/member/account')
        })
        return
      }
      this.OrderModel.total_price = this.mathTotalPrice
      this.OrderModel.total_pv = this.mathTotalPv
      this.OrderModel.order_items = this.ListModel.data
        .filter(model => {
          return this.maxLimitedBuy(model.products)
        })
        .map(
          p =>
            new OrderItemModel({
              ...p,
              fortune_birth_at:
                p.fortune_year && p.fortune_month && p.fortune_day
                  ? `${p.fortune_year}-${p.fortune_month}-${p.fortune_day}`
                  : undefined
            })
        )
      // console.log('step 1 this.OrderModel', this.OrderModel)
      // console.log('step 1 this.OrderModel.order_items', this.OrderModel.order_items)

      this.$parent.step = 2
      this.$router.push('2')
      this.getListModel({ name: 'Offices' })
      // this.getListModel({ name: 'GeneralAddress' })
    },
    // 活動相關
    async getActivitiesListModel() {
      // 完整核對會重新取得活動資料；保留會員已選的贈品，避免按「下一步」
      // 後因活動 model 被重建而要求重選。若最新資格或配額降低，下面仍會
      // 依最新 selected_gift / remaining_gift_quota 自動縮減。
      const selectedGifts = new Map(
        this.OrderModel.activities.map(activity => [
          Number(activity.id),
          activity.activity_items.map(item => ({
            id: Number(item.id),
            product_number: item.product_number,
            quantity: Number(item.gift_quantity || 0)
          }))
        ])
      )
      const selectedGiftItems = this.activity_items.map(item => ({
        id: Number(item.id),
        product_number: item.product_number,
        quantity: Number(item.gift_quantity || 0)
      }))
      return this.getListModel({ name: 'Activities' }).then(async () => {
        // console.log(' getActivitiesListModel', this.Activities.data)
        const refreshedActivities = this.Activities.data.map(
          p => new ActivitieModel(p)
        )
        const activityProductLoads = []
        refreshedActivities.forEach(a => {
          if (a.ruleable.freebie && a.ruleable.freebie.id) {
            activityProductLoads.push(a.ruleable.freebie.getData())
          }
          // console.log(' this.OrderModel.activities', a)
          a.ruleable.freebies.forEach(m =>
            activityProductLoads.push(m.getData())
          )
          a.ruleable.freebies_range.forEach(m =>
            activityProductLoads.push(m.getData())
          )
          a.ruleable.raffle_list.forEach(m =>
            activityProductLoads.push(m.getData())
          )
          // console.log('a.ruleable.freebies_range', a.ruleable.freebies_range)
          // console.log('a.ruleable.remaining_quota ', a.ruleable.remaining_quota, a.ruleable_type)
          if (a.ruleable.remaining_quota <= 0) {
            const found = this.OrderModel.agree_freebie_none_ids.find(
              element => element === a.id
            )
            // console.log('found', found)
            if (found === undefined) {
              this.OrderModel.agree_freebie_none_ids.push(a.id)
            }
          }
          a.show = 1
          a.hasLimit = this.isActivityLimit(a)
          // console.log('foreach activities', a)
        })
        await Promise.all(activityProductLoads)
        // 在新活動資料及贈品商品全部完成前保留舊畫面，避免選擇按鈕閃爍消失。
        const refreshedActivityItems = []
        this.mathRule(refreshedActivities, refreshedActivityItems)
        refreshedActivities.forEach(activity => {
          if (!activity.ruleable_type.includes('RuleProduct')) {
            return
          }

          const previousItems =
            selectedGifts.get(Number(activity.id)) || selectedGiftItems
          let selectableQuantity = Number(activity.ruleable.selected_gift || 0)
          activity.ruleable.freebies.forEach(gift => {
            const previous = previousItems.find(
              item =>
                item.id === Number(gift.id) ||
                item.product_number === gift.product_number
            ) || selectedGiftItems.find(
              item =>
                item.id === Number(gift.id) ||
                item.product_number === gift.product_number
            )
            const quantity = Math.min(
              Number(previous ? previous.quantity : 0),
              Number(gift.remaining_gift_quota || 0),
              selectableQuantity
            )
            gift.gift_quantity = Math.max(quantity, 0)
            selectableQuantity -= gift.gift_quantity
          })
          activity.activity_items = activity.ruleable.freebies.filter(
            gift => Number(gift.gift_quantity) > 0
          )
        })
        this.OrderModel.activities = refreshedActivities
        this.activity_items = refreshedActivityItems
        this.updateView()

        Swal.close()
      })
    },
    isActivityLimit(activitie) {
      // 判斷是否參加活動
      if (process.env.NODE_ENV === 'development') {
        // console.log(activitie.title, 'isActivityLimit', activitie.ruleable.activity_limit_products.map(p => p.id))
        // console.log(activitie.title, 'isActivityLimit', this.ListModel.data.map(p => `${p.products.id}:${p.products.name}:${p.products.product_number}`))
      }
      return this.ListModel.data.some(shopcart => {
        return activitie.ruleable.activity_limit_products.some(
          p => Number(p.id) === Number(shopcart.product_id)
        )
      })
    },
    inShopCartProduct(activitie) {
      // 能夠參與該活動的商品
      const activityProductsId = activitie.ruleable.activity_products.map(p =>
        Number(p.id)
      )
      if (process.env.NODE_ENV === 'development') {
        // console.log(activitie.title, 'inShopCartProduct', activityProductsId)
        // console.log(activitie.title, 'inShopCartProduct', this.ListModel.data.map(p => `${p.products.id}:${p.products.name}:${p.products.product_number}`))
      }
      return this.ListModel.data.filter(p =>
        activityProductsId.includes(Number(p.products.id))
      )
    },
    mathRule(
      activities = this.OrderModel.activities,
      activityItems = this.activity_items
    ) {
      // 更新活動計算結果
      console.log('?3')
      return activities.map(a => {
        if (a.ruleable_type.includes('RuleFixedPv')) {
          return this.mathRuleFixedPv(a, activityItems)
        }
        if (a.ruleable_type.includes('RuleRangePv')) {
          return this.mathRuleRangePv(a, activityItems)
        }
        if (a.ruleable_type.includes('RuleProduct')) {
          return this.mathRuleProduct(a)
        }
        if (a.ruleable_type.includes('RuleRaffle')) {
          return this.mathRuleRaffle(a)
        }
        return new ActivitieModel()
      })
    },
    mathRuleFixedPv(activitie, activityItems = this.activity_items) {
      // 固定積分運算
      // if (process.env.NODE_ENV === 'development') console.log('%cmathRuleFixedPv', 'color: red;', activitie.ruleable)
      const quota = activitie.ruleable.remaining_quota || 0
      if (this.isActivityLimit(activitie)) {
        const maxIterative = activitie.ruleable.max_iterative || 0
        const perBuyPv = activitie.ruleable.per_buy_pv
        const quantity = activitie.ruleable.per_freebie_quantity
        const freebie = activitie.ruleable.freebie
        let pv = 0
        if (quota > 0) {
          const iterative = this.inShopCartProduct(activitie).reduce(
            (acc, shopcart) => {
              pv += shopcart.products.pv * shopcart.product_quantity
              return Math.floor(pv / perBuyPv)
            },
            0
          )
          // if (process.env.NODE_ENV === 'development') console.log('iterative > maxIterative', iterative, maxIterative)
          activitie.errorCondition.iterative = iterative > maxIterative
          // console.log('maxIterative', maxIterative)
          // console.log('iterative', iterative)

          if (freebie) {
            let giftQuantity = 0 // iterative * quantity
            // console.log('quota', quota)
            if (iterative > maxIterative) {
              giftQuantity = maxIterative * quantity
            } else {
              giftQuantity = iterative * quantity
            }
            freebie.gift_quantity = giftQuantity
            if (giftQuantity > quota) {
              activitie.errorCondition.quota = true
              freebie.gift_quantity = quota
            } else {
              activitie.errorCondition.quota = false
            }

            // console.log('giftQuantity', giftQuantity)
          }
          activitie.activity_items =
            freebie && freebie.gift_quantity ? [freebie] : []
          if (freebie && freebie.gift_quantity) {
            activityItems.push(freebie)
          }

          // console.log('mathRuleFixedPv activitie.activity_items', activitie.activity_items)
          // activitie.errorCondition.quota = false
          // if (process.env.NODE_ENV === 'development') console.log('mathRuleFixedPv:gift_quantity', `Math.min(iterativeCount:${iterativeCount} * quantity:${quantity} , quota:${quota} )`)
        } else {
          activitie.errorCondition.quota = true
        }
      }
      return activitie
    },
    mathRuleRangePv(activitie, activityItems = this.activity_items) {
      // 範圍積分運算
      // if (process.env.NODE_ENV === 'development') console.log('%cmathRuleRangePv', 'color: blue;', activitie.ruleable)
      if (this.isActivityLimit(activitie)) {
        const quota = activitie.ruleable.remaining_quota || 0
        if (quota > 0) {
          const freebiesRange = activitie.ruleable.freebies_range
          // console.log('freebiesRange', freebiesRange)
          const totalPv = this.inShopCartProduct(activitie).reduce(
            (pv, shopcart) => {
              return pv + shopcart.products.pv * shopcart.product_quantity
            },
            0
          )
          const freebie = freebiesRange.find(f => {
            // if (process.env.NODE_ENV === 'development') console.log('mathRuleRangePv:Range', `totalPv:${totalPv} >= pv_start:${f.pv_start} && totalPv:${totalPv} <= pv_end:${f.pv_end}`, totalPv >= f.pv_start && totalPv <= f.pv_end)
            return totalPv >= f.pv_start && totalPv <= f.pv_end
          })
          // console.log('freebie', freebie)
          // console.log('totalPv', totalPv)
          if (freebie) {
            if (freebie.gift_quantity > quota) {
              activitie.errorCondition.quota = true
              // freebie.gift_quantity = quota
            } else {
              activitie.errorCondition.quota = false
            }
          }
          activitie.activity_items =
            freebie && freebie.gift_quantity ? [freebie] : []
          // this.activity_items = freebie && freebie.gift_quantity ? [freebie] : []

          if (freebie && freebie.gift_quantity) {
            activityItems.push(freebie)
          }
          // console.log('mathRuleRangePv activitie.activity_items', activitie.activity_items)

          // activitie.errorCondition.quota = false
          // if (process.env.NODE_ENV === 'development') console.log('mathRuleRangePv:gift_quantity', `freebie:${freebie && freebie.name}Math.min(gift_quantity:${freebie && freebie.gift_quantity}, quota:${quota})`)
        } else {
          activitie.errorCondition.quota = true
        }
      }
      return activitie
    },
    mathRuleProduct(activitie) {
      // 買A送B運算
      // if (process.env.NODE_ENV === 'development') console.log('%cmathRuleProduct', 'color: purple;', activitie.ruleable)
      const quota = activitie.ruleable.remaining_quota || 0 // 總數
      const perBuyQuantity = activitie.ruleable.per_buy_quantity // 買幾個
      const quantity = activitie.ruleable.per_freebie_quantity // 送幾個
      const totalQuantity = this.inShopCartProduct(activitie).reduce(
        (quantity, shopcart) => quantity + shopcart.product_quantity,
        0
      )
      const giftQuantity = Math.floor(totalQuantity / perBuyQuantity) * quantity // 可以送幾個
      if (giftQuantity < activitie.ruleable.selected_gift) {
        // 送的數量小於選擇
        activitie.activity_items = [] // 更新規則就從讀
      }
      console.log('activitie', activitie)
      // this.model.activities.map(a => {
      //   console.log('inin:', a.activity_items)
      //   this.activity_items = this.activity_items.concat(a.activity_items)
      //   return a.activity_items
      // })
      // console.log('giftQuantity', giftQuantity)
      if (giftQuantity > quota) {
        activitie.errorCondition.quota = true
        activitie.ruleable.selected_gift = quota
      } else {
        activitie.errorCondition.quota = false
        activitie.ruleable.selected_gift = giftQuantity
      }

      activitie.ruleable.freebies.map(a => {
        a.gift_quantity = 0
        return a
      })
      // if (process.env.NODE_ENV === 'development') console.log('mathRuleProduct:selected_gift', `Math.min(Math.floor(totalQuantity:${totalQuantity} / perBuyQuantity:${perBuyQuantity}) * quantity:${quantity} , quota:${quota})`, activitie.ruleable.selected_gift)
      // console.log('mathRuleProduct', activitie.ruleable)
      return activitie
    },
    mathRuleRaffle(activitie) {
      // 抽獎運算
      // if (process.env.NODE_ENV === 'development') console.log('%cmathRuleRaffle', 'color: green;', activitie.ruleable)
      return activitie
    },
    handleActivity() {
      // 與畫面顯示活動使用相同集合，避免隱藏／測試活動干擾判斷。
      return this.finalActivities.some(activitie => {
        if (!activitie.ruleable_type.includes('RuleProduct')) {
          return false
        }

        const selectableQuantity = Number(
          activitie.ruleable.selected_gift || 0
        )
        const selectedQuantity = activitie.activity_items.reduce(
          (total, item) => total + Number(item.gift_quantity || 0),
          0
        )

        return (
          Number(activitie.ruleable.remaining_quota || 0) > 0 &&
          selectableQuantity > 0 &&
          selectedQuantity < selectableQuantity
        )
      })
    }
  },
  components: {
    ProdGrid,
    ActivitieGrid,
    ActivitieProdGrid,
    ActivitieProdGridItem
  }
}
</script>

<style lang="scss" scoped>
.grid-table {
  .title {
    padding: 12px 0;
    @media (max-width: 991.5px) {
      display: none;
    }
  }
}
</style>
